module.exports = "<div class=\"ubg-banner-actions\">\n  <ng-content></ng-content>\n</div>"